package one.healthium.data.health_log

import kotlinx.serialization.Serializable
import one.healthium.domain.health_log.models.HealthLogQuestionModel

@Serializable
data class HealthLogDataDto(
    val questions: List<HealthLogQuestionModel>,
)
